import $ from '@ali/tarzan-zepto';
import events from 'events';
import util from '../util';
// 动画频率
const INTERVAL = 66;
// 相邻波动差值需要控制在这个阀值内
const DIFF_THRESHOLD = 20;
// 没有信息时,获取一个相对平滑的值.
const SMOOTH_STEP = 5;

// 正常音量
// android 采集的信息在 (0, 20) (40, 60) (90, 100) 这几个区间较频繁;很容易出现 100
// ios 基本分布在 (30, 80)
const MIN_RANGE = $.ios ? 30 : 0;
const MAX_RANGE = $.ios ? 80 : 100;
const MIN_VALUE = 5;
const MAX_VALUE = 60;
const STEP = 5;

class Wave extends events {
  constructor(cfg) {
    super();
    this.$wrap = $(cfg.el);
    this.$items = this.$wrap.find('.wave-item');
    this.direction = cfg.direction || 'right';

    this.count = this.$items.length;

    this.__reset();
  }

  start() {
    this.running = true;
    this.__clock = this.__start = +new Date();
    this.__loop();
    this.__countdown();
  }

  stop() {
    this.__reset();
    this.__render();
  }

  push(val) {
    this.__queue.push(val);
    // (this.__cache || (this.__cache = [])).push(val);
  }

  __reset() {
    this.running = false;
    this.__start = null;
    this.__queue = [];
    this.__status = [];
    if (this.__counter)clearTimeout(this.__counter);
    this.__timer = null;
    this.__counter = null;
  }

  __loop() {
    if (!this.running) {
      return;
    }

    const now = +new Date();
    // 避免过于频繁
    if (now - this.__clock > INTERVAL) {
      this.__clock = now;
      const status = this.__status;
      const val = this.__getNewStatus(status);

      status.unshift(val);
      while (status.length < this.count) {
        status.push(0);
      }
      while (status.length > this.count) {
        status.pop();
      }

      util.requestAnimationFrame(() => {
        this.__render(status);
      });
    }

    this.__timer = util.requestAnimationFrame(() => {
      this.__loop();
    });
  }

  __getNewStatus(status) {
    const queue = this.__queue;
    const lastValue = (1 * status[0]) || 0;
    let val = queue.pop() * 1;
    queue.length = 0;

    // android的采集频率较低,有可能没有缓存的值,此时就根据上一个状态得到一个平滑值
    if (!val) {
      val = lastValue === 0 ? 0 : Math.abs(lastValue - SMOOTH_STEP);
    }

    // 如果相邻值的差值超过平滑的阀值,则根据平滑的需求来获取一个新值
    while (Math.abs(val - lastValue) > DIFF_THRESHOLD) {
      val = Math.floor((val + lastValue) / 2);
    }

    return val;
  }

  __render(status = []) {
    let statusBar = status;
    if (this.direction === 'left') {
      statusBar = [].concat(statusBar).reverse();
    }

    this.$items.each((idx, item) => {
      $(item).height(this.__calcHeight(statusBar[idx]));
    });
  }

  // 根据采集到的音量值,计算显示的高度
  __calcHeight(volume = 0) {
    if (volume < MIN_RANGE) {
      return MIN_VALUE;
    } else if (volume >= MAX_RANGE) {
      return MAX_VALUE;
    }

    // let unit = (MAX_RANGE - MIN_RANGE) * STEP / (MAX_VALUE - MIN_VALUE);
    // return MIN_VALUE + Math.floor(volume / unit) * STEP;

    return MIN_VALUE + ((volume - MIN_RANGE) /
      ((MAX_VALUE - MIN_VALUE) / STEP)) * STEP;
  }

  __countdown() {
    const current = +new Date();
    const MAX = 18;
    const cd = Math.floor((current - this.__start) / 1000);
    const remain = Math.floor(MAX - cd);
    if (remain >= 0) {
      this.emit('count', remain);

      this.__counter = setTimeout(() => {
        this.__countdown();
      }, 1000);
    } else {
      this.emit('end');
    }
  }
}

export default Wave;



// WEBPACK FOOTER //
// ./src/lib/voice/wave.js